import { render, staticRenderFns } from "./DietaryRestrictionsCustom.vue?vue&type=template&id=4e57af71&scoped=true"
import script from "./DietaryRestrictionsCustom.vue?vue&type=script&lang=js"
export * from "./DietaryRestrictionsCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e57af71",
  null
  
)

export default component.exports